import { Button, Col, Dropdown, Form, Select, Row, Tooltip } from 'antd';
import React ,{ useState ,useEffect, useCallback} from 'react';

const CustomerTranasactionFilters = (props) => {
    const [open, setOpen] = useState(false);
    const [form]=Form.useForm()
    useEffect(() =>{
        form.setFieldsValue(props?.filterValues);
        if (props?.onloadGrid) {
            props.onloadGrid();}
    },[props?.filterValues])

    const handleSearch = useCallback((values) => {
        props?.filterObj(values);
        setOpen(false)
    },[props])

    const handleOpenChange = useCallback((nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setOpen(nextOpen);
        }
    },[])
    
    const handleMenuClick = (e) => {
        if (e.key === '3') {
            setOpen(false);
        }
    };
    const clearRecords = useCallback(() => {
        props?.filterObj({"transactionType": "All" });
        form.resetFields()
      },[form,props])

    const items = [
        {
            label: 
                <Form className="grid-filter-form"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form}>
                    <p className='filter-option-title'>Filter Options</p>
                    <Row gutter={[16]} className='filters-row'>
                    <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                name="transactionType"
                                label="Transaction Type"
                            >
                                <Select
                                    className=""
                                    placeholder={`Select Transaction Type`}
                                    defaultValue={"All"}
                                >
                                    {props?.typeLu?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                </Row>
                <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                <Button className='cancel-btn' onClick={clearRecords} key="back">Clear</Button>
              <Button className='primary-btn' type="primary" htmlType="submit">Search</Button>
              </div>
            </Form>
            ,
            key: '1',
        },
      ];

    const filterModelHandler=useCallback((e)=>{
        e.preventDefault()
      },[])

    return (
        
            <div className='flex gap-2 justify-end items-center mb-3'>
                 <Dropdown
            overlayClassName='filterdropdown-overlay'
             className='filter-dropdown'
                 menu={{
                     items,
                     onClick: handleMenuClick,
                 }}
                 onOpenChange={handleOpenChange}
                 open={open}
                 trigger={'click'}
             >
                 <a onClick={filterModelHandler} className=''>
                 <Tooltip title='Filter'>   <span className='icon filter-icon-dropdown'></span></Tooltip>
                 </a>
             </Dropdown>
             </div>
        
    )
}
export default React.memo(CustomerTranasactionFilters);